import React, { useState, useEffect, useCallback } from "react";
import {
  Container,
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
} from "@material-ui/core";
import {
  Typography,
  AppBar,
  Toolbar,
  Link,
  CardActionArea,
  TextField,
  Button,
  Paper,
  FormControlLabel,
  Checkbox,
  IconButton,
  Stepper,
  Step,
  StepLabel,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  ListItemSecondaryAction,
  Switch,
  Divider,
  ButtonGroup,
  Avatar,
} from "@material-ui/core";
import {
  Grid,
  Dialog,
  DialogActions,
  DialogTitle,
  DialogContent,
  DialogContentText,
  LinearProgress,
  CircularProgress,
} from "@material-ui/core";
import {
  Close,
  Edit,
  Block,
  CheckCircle,
  DesktopMac,
  Add,
  FilterList,
  Settings,
  ArrowForwardIos,
  Image,
  Attachment,
} from "@material-ui/icons";
import DateFnsUtils from "@date-io/date-fns";
import { MuiPickersUtilsProvider, DatePicker } from "@material-ui/pickers";

import { withLocalize, Translate } from "react-localize-redux";
import { useHistory } from "react-router-dom";

import Dropzone from "react-dropzone";

import { useSnackbar } from "notistack";
import { makeStyles, useTheme } from "@material-ui/styles";

import { AdminService, Permissions } from "./../../../utils/web_config";

import Format from "date-fns/format";

import axiosRetry from "axios-retry";
const axios = require("axios");
axiosRetry(axios, { retries: 3 });

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  title: {
    flexGrow: 1,
  },
  btn: {
    textTransform: "capitalize",
  },
  btn2: {
    textTransform: "capitalize",
    border: "dashed grey 1px",
  },
  paper: {
    padding: 15,
  },
  action: {
    borderRadius: 15,
  },
}));

function getSteps() {
  return ["Operator info", "Finish edit"];
}

function OperatorDetails(props) {
  const classes = useStyles();
  const history = useHistory();
  const Theme = useTheme();

  const { data, logo } = props;

  const [activeStep, setActiveStep] = useState(0);
  const steps = getSteps();

  const [accountData, setAccountData] = useState({});
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const [operators, setOperators] = useState({
    saving: false,
    loadfing: false,
    edit: false,
    toggling: false,
  });

  const [value, setValue] = useState(false);

  const [warning, setWarning] = useState(false);

  const [operatorName, setName] = useState({ value: "", error: "" });
  const [operatorEmail, setEmail] = useState({ value: "", error: "" });
  const [operatorPhone, setPhone] = useState({ value: "", error: "" });
  const [operatorAddress, setAddress] = useState({ value: "", error: "" });
  const [operatorShortName, setShortName] = useState({ value: "", error: "" });

  const [operatorWebsite, setWebsite] = useState({ value: "", error: "" });
  const [operatorTin, setTin] = useState({ value: "", error: "" });
  const [operatorFax, setFax] = useState({ value: "", error: "" });
  const [operatorZip, setZip] = useState({ value: "", error: "" });
  const [operatorContractNumber, setContractNumber] = useState({
    value: "",
    error: "",
  });
  const [operatorCotractStart, setCotractStart] = useState({
    value: new Date(),
    error: "",
  });
  const [operatorContractEnd, setContractEnd] = useState({
    value: new Date(),
    error: "",
  });

  const [operatorSettlementBankAccount, setSettlementBankAccount] = useState({
    value: "",
    error: "",
  });
  const [operatorSettlementBankAccountName, setSettlementBankAccountName] = useState({
    value: "",
    error: "",
  });

  const [bankCode, setBankCode] = useState({ value: "", error: "" });

  const [posConfig, setPosConfig] = useState({ value: "", error: "" });

  const handleBack = () => {
    setActiveStep(activeStep - 1);
  };

  const [choosenFile, setChoosenFile] = useState([]);

  /////////////////////

  useEffect(() => {
    var accountData = new AdminService().accountData;
    setAccountData(accountData);

    fillForm();
  }, []);

  ///////////////

  const onNameChange = (event) => {
    if (event.target.value === "") {
      setName({
        value: "",
        error: (
          <Translate>
            {({ translate }) =>
              translate("operators.forms.hints.operator_name")
            }
          </Translate>
        ),
      });
    } else {
      setName({ value: event.target.value, error: "" });
    }
  };
  const onEmailChange = (event) => {
    if (event.target.value === "") {
      setEmail({
        value: "",
        error: (
          <Translate>
            {({ translate }) =>
              translate("operators.forms.hints.operator_email")
            }
          </Translate>
        ),
      });
    } else {
      setEmail({ value: event.target.value, error: "" });
    }
  };
  const onPhoneChange = (event) => {
    if (event.target.value === "") {
      setPhone({
        value: "",
        error: (
          <Translate>
            {({ translate }) =>
              translate("operators.forms.hints.operator_phone")
            }
          </Translate>
        ),
      });
    } else {
      setPhone({ value: event.target.value, error: "" });
    }
  };
  const onAddressChange = (event) => {
    if (event.target.value === "") {
      setAddress({
        value: "",
        error: (
          <Translate>
            {({ translate }) =>
              translate("operators.forms.hints.operator_address")
            }
          </Translate>
        ),
      });
    } else {
      setAddress({ value: event.target.value, error: "" });
    }
  };
  const onShortNameChange = (event) => {
    if (event.target.value === "") {
      setShortName({
        value: "",
        error: (
          <Translate>
            {({ translate }) =>
              translate("operators.forms.hints.operator_short_name")
            }
          </Translate>
        ),
      });
    } else {
      setShortName({ value: event.target.value, error: "" });
    }
  };

  const onWebsiteChange = (event) => {
    if (event.target.value === "") {
      setWebsite({
        value: "",
        error: (
          <Translate>
            {({ translate }) =>
              translate("operators.forms.hints.operator_website")
            }
          </Translate>
        ),
      });
    } else {
      setWebsite({ value: event.target.value, error: "" });
    }
  };
  const onTinChange = (event) => {
    if (event.target.value === "") {
      setTin({
        value: "",
        error: (
          <Translate>
            {({ translate }) => translate("operators.forms.hints.operator_tin")}
          </Translate>
        ),
      });
    } else {
      setTin({ value: event.target.value, error: "" });
    }
  };
  const onFaxChange = (event) => {
    if (event.target.value === "") {
      setFax({
        value: "",
        error: (
          <Translate>
            {({ translate }) => translate("operators.forms.hints.operator_fax")}
          </Translate>
        ),
      });
    } else {
      setFax({ value: event.target.value, error: "" });
    }
  };
  const onZipChange = (event) => {
    if (event.target.value === "") {
      setZip({
        value: "",
        error: (
          <Translate>
            {({ translate }) => translate("operators.forms.hints.operator_zip")}
          </Translate>
        ),
      });
    } else {
      setZip({ value: event.target.value, error: "" });
    }
  };
  const onContractNumberChange = (event) => {
    if (event.target.value === "") {
      setContractNumber({
        value: "",
        error: (
          <Translate>
            {({ translate }) =>
              translate("operators.forms.hints.operator_contract_number")
            }
          </Translate>
        ),
      });
    } else {
      setContractNumber({ value: event.target.value, error: "" });
    }
  };

  const onPosConfigChange = (event) => {
    if (event.target.value === "") {
      setPosConfig({
        value: "",
        error: (
          <Translate>
            {({ translate }) => translate("operators.forms.hints.pos_config")}
          </Translate>
        ),
      });
    } else {
      setPosConfig({ value: event.target.value, error: "" });
    }
  };

  const onSettlementBankAccountChange = (event) => {
    if (event.target.value === "") {
      setSettlementBankAccount({
        value: "",
        error: (
          <Translate>
            {({ translate }) =>
              translate(
                "operators.forms.hints.operator_settlement_bank_account"
              )
            }
          </Translate>
        ),
      });
    } else {
      setSettlementBankAccount({ value: event.target.value, error: "" });
    }
  };

  const onSettlementBankAccountNameChange = (event) => {
    if (event.target.value === "") {
      setSettlementBankAccountName({
        value: "",
        error: (
          <Translate>
            {({ translate }) =>
              translate(
                "operators.forms.hints.operator_settlement_bank_account_name"
              )
            }
          </Translate>
        ),
      });
    } else {
      setSettlementBankAccountName({ value: event.target.value, error: "" });
    }
  };

  const onBankCode = (event) => {
    if (event.target.value === "") {
      setBankCode({
        value: "",
        error: (
          <Translate>
            {({ translate }) =>
              translate("operators.forms.hints.operator_settlement_bank_code")
            }
          </Translate>
        ),
      });
    } else {
      setBankCode({ value: event.target.value, error: "" });
    }
  };
  const onCnotractStartChange = (date) => {
    setCotractStart({ value: date, error: "" });
  };
  const onContractEndChange = (date) => {
    setContractEnd({ value: date, error: "" });
  };

  //////////////////////

  const onRegisterClick = () => {
    if (operatorName.value === "") {
      setName({
        value: "",
        error: (
          <Translate>
            {({ translate }) =>
              translate("operators.forms.hints.operator_name")
            }
          </Translate>
        ),
      });
    } else if (operatorEmail.value === "") {
      setEmail({
        value: "",
        error: (
          <Translate>
            {({ translate }) =>
              translate("operators.forms.hints.operator_email")
            }
          </Translate>
        ),
      });
    } else if (operatorPhone.value === "") {
      setPhone({
        value: "",
        error: (
          <Translate>
            {({ translate }) =>
              translate("operators.forms.hints.operator_phone")
            }
          </Translate>
        ),
      });
    } else if (operatorAddress.value === "") {
      setAddress({
        value: "",
        error: (
          <Translate>
            {({ translate }) =>
              translate("operators.forms.hints.operator_address")
            }
          </Translate>
        ),
      });
    } else if (operatorShortName.value === "") {
      setShortName({
        value: "",
        error: (
          <Translate>
            {({ translate }) =>
              translate("operators.forms.hints.operator_short_name")
            }
          </Translate>
        ),
      });
    } else if (operatorTin.value === "") {
      setTin({
        value: "",
        error: (
          <Translate>
            {({ translate }) => translate("operators.forms.hints.operator_tin")}
          </Translate>
        ),
      });
    } else if (operatorZip.value === "") {
      setZip({
        value: "",
        error: (
          <Translate>
            {({ translate }) => translate("operators.forms.hints.operator_zip")}
          </Translate>
        ),
      });
    } else if (operatorContractNumber.value === "") {
      setContractNumber({
        value: "",
        error: (
          <Translate>
            {({ translate }) =>
              translate("operators.forms.hints.operator_contract_number")
            }
          </Translate>
        ),
      });
    } else if (operatorSettlementBankAccount.value === "") {
      setSettlementBankAccount({
        value: "",
        error: (
          <Translate>
            {({ translate }) =>
              translate(
                "operators.forms.hints.operator_settlement_bank_account"
              )
            }
          </Translate>
        ),
      });
    } else if (operatorCotractStart.value === "") {
      setCotractStart({
        value: "",
        error: (
          <Translate>
            {({ translate }) =>
              translate("operators.forms.hints.operator_contract_start")
            }
          </Translate>
        ),
      });
    } else if (operatorContractEnd.value === "") {
      setContractEnd({
        value: "",
        error: (
          <Translate>
            {({ translate }) =>
              translate("operators.forms.hints.operator_contract_end")
            }
          </Translate>
        ),
      });
    } else {
      setActiveStep(1);
      if (activeStep === 1) {
        updateOp();
      }
    }
  };
  ///////////////
  ///////////////////////////////

  const fillForm = () => {
    setOperators({ ...operators, data: data });
    setContractEnd({ value: new Date(data.contract_end_date), error: "" });
    setCotractStart({ value: new Date(data.contract_start_date), error: "" });
    setContractNumber({ value: data.contract_number, error: "" });
    setEmail({ value: data.email, error: "" });
    setFax({ value: data.fax_number, error: "" });
    setAddress({ value: data.full_address, error: "" });
    setName({ value: data.name, error: "" });
    setPhone({ value: data.phone_number, error: "" });
    setShortName({ value: data.short_name, error: "" });
    setTin({ value: data.tin, error: "" });
    setWebsite({ value: data.website, error: "" });
    setZip({ value: data.zip_number, error: "" });
    setPosConfig({ value: data.pos_device_configuration, error: "" });
    setSettlementBankAccount({
      value: data.settlement_bank_account,
      error: "",
    });
    setSettlementBankAccountName({
      value: data.settlement_bank_account_name,
      error: "",
    });
    setBankCode({value:data.settlement_bank_code,error:""})
  };
  /////////

  const notify = (variant, msg, status) => {
    if (status == 401) {
      history.push("/", { expired: true });
    }
    enqueueSnackbar(msg, {
      variant: variant,
      action: (k) => (
        <IconButton
          onClick={() => {
            closeSnackbar(k);
          }}
          size="small"
        >
          <Close fontSize="small" />
        </IconButton>
      ),
    });
  };

  const changeLogo = () => {
    if (choosenFile.length == 0) {
      notify("error", "choose another logo first");
      return;
    }

    upload();
  };

  // async function getBase64(file) {

  //   var reader = new FileReader();

  //   var res;
  //   reader.readAsDataURL(file);
  //   reader.onload = function () {
  //     res = reader.result;
  //     updateOp(res);
  //   };
  //   reader.onerror = function (error) {
  //     notify("error", "Error processing your image logo");
  //   };
  // }

  ///////////////////////////////////
  const updateOp = (logo) => {
    const createInstance = axios.create(
      new AdminService().getHeaders(accountData.token)
    );
    setOperators({ ...operators, saving: true });

    const data2 = {
      booking_limit: 0,
      contract_end_date: Format(operatorContractEnd.value, [
        "yyyy-MM-dd HH:mm:ss",
      ]),
      contract_number: operatorContractNumber.value,
      contract_start_date: Format(operatorCotractStart.value, [
        "yyyy-MM-dd HH:mm:ss",
      ]),
      email: operatorEmail.value,
      fax_number: operatorFax.value,
      full_address: operatorAddress.value,
      name: operatorName.value,
      organization_type: "OPERATOR",
      phone_number: operatorPhone.value,
      registration_date: Format(new Date(), ["yyyy-MM-dd HH:mm:ss"]),
      short_name: operatorShortName.value,
      tin: operatorTin.value,
      website: operatorWebsite.value,
      zip_number: operatorZip.value,
      settlement_bank_account: operatorSettlementBankAccount.value,
      settlement_bank_account_name:operatorSettlementBankAccountName.value,
      pos_device_configuration: posConfig.value,
      settlement_bank_code:bankCode.value
    };

    console.log("Editing operator .....");
    console.log(data2);
    createInstance
      .put(new AdminService().UPDATE_ORGANIZATION + data.organization_id, data2)
      .then(function (response) {
        setOperators({ ...operators, saving: false });

        const d = response.data;

        setOperators({ ...operators, data: d.data });

        notify("success", response.data.message);
        setOperators({ ...operators, edit: false });
        setActiveStep(0);
        setChoosenFile([]);
      })
      .catch(function (error) {
        setOperators({ ...operators, saving: false });

        var e = error.message;
        if (error.response) {
          e = error.response.data.message;
        }
        notify(
          error?.response?.status == 404 ? "info" : "error",
          e,
          error?.response?.status
        );
      });
  };

  //////////////////////////////////////
  const toggleOperator = () => {
    const agInstance = axios.create(
      new AdminService().getHeaders(accountData.token)
    );

    setOperators({ ...operators, toggling: true });

    var url;
    if (data.organization_status == "ENABLED") {
      url = new AdminService().DEACTIVATE_ORGANIZATION + data.organization_id;
      data["organization_status"] = "DISABLED";
    } else {
      url = new AdminService().REACTIVATE_ORGANIZATION + data.organization_id;
      data["organization_status"] = "ENABLED";
    }

    agInstance
      .put(url)
      .then(function (response) {
        const d = response.data;
        setOperators({ ...operators, toggling: false });

        notify("success", d.data);
      })
      .catch(function (error) {
        setOperators({ ...operators, toggling: false });

        data["organization_status"] =
          data.organization_status == "ENABLED" ? "DISABLED" : "ENABLED";
        var e = error.message;

        if (error.response) {
          e = error.response.data.message;
        }
        notify(
          error?.response?.status == 404 ? "info" : "error",
          e,
          error?.response?.status
        );
      });
  };

  ////////////////////////
  const upload = () => {
    if (choosenFile.length == 0) {
      notify("error", "Please select logo to upload");
    } else {
      const createInstance = axios.create({
        ...new AdminService().getHeaders(accountData.token),
        "Content-Type": "multipart/form-data",
      });

      var data = new FormData();

      data.append("logo_file", choosenFile[0]);

      setOperators({ ...operators, saving: true });

      console.log("Uploading items.....");

      createInstance
        .put(
          new AdminService().UPLOAD_ORGANIZATION_LOGO +
            operators.data.organization_id,
          data
        )
        .then(function (response) {
          console.log(response.data);
          setOperators({ ...operators, saving: false });
          var d = response.data;

          setChoosenFile([]);
          notify("success", response.data.message);
        })
        .catch(function (error) {
          console.log(error);
          setOperators({ ...operators, saving: false });
          var e = error.message;

          if (error.response) {
            e = error.response.data.message;
          }

          notify(
            error?.response?.status == 404 ? "info" : "error",
            e,
            error?.response?.status
          );
        });
    }
  };

  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <div className={classes.root}>
        {/* Dialogs ends here */}

        <Dialog
          open={warning}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">{"Warning"}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              You are about to deactivate this operator, all his actions and
              transactions will stop working until you reactivate him.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => {
                setWarning(false);
              }}
              color="primary"
            >
              Cancel
            </Button>
            <Button
              onClick={() => {
                setWarning(false);
                toggleOperator();
              }}
              color="primary"
              autoFocus
            >
              Deactivate
            </Button>
          </DialogActions>
        </Dialog>
        {/* ///////////////////////////////////// */}

        <Box mt={3} />
        <Grid container justify="center">
          <Grid item xs={12} md={10}>
            <Box display="flex" justifyContent="center" mt={2} mb={1}>
              <Avatar
                style={{ height: 120, width: 120 }}
                src={
                  choosenFile.length != 0
                    ? choosenFile[0]?.preview
                    : "data:image/jpg;base64," + logo
                }
              >
                <Image fontSize="large" />
              </Avatar>
            </Box>
            <Box pb={2} display="flex" justifyContent="center">
              <Button
                color="primary"
                className={classes.btn}
                startIcon={<Edit />}
                onClick={() => setValue(!value)}
              >
                Edit operator logo
              </Button>
            </Box>
            {value && (
              <Box mb={2} mr={2} display="flex" justifyContent="center">
                <Dropzone
                  onDrop={(acceptedFiles) => {
                    console.log(JSON.stringify(acceptedFiles));
                    setChoosenFile(
                      acceptedFiles.map((file) =>
                        Object.assign(file, {
                          preview: URL.createObjectURL(file),
                        })
                      )
                    );
                  }}
                  accept="image/png, image/gif, image/jpeg"
                  multiple={false}
                  noClick={choosenFile.length != 0}
                >
                  {({
                    getRootProps,
                    getInputProps,
                    isDragActive,
                    isDragReject,
                  }) => (
                    <CardActionArea disableRipple={choosenFile.length != 0}>
                      {" "}
                      <Box
                        borderRadius="borderRadius"
                        p={2}
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                        style={{ border: "dashed 1px grey" }}
                        {...getRootProps()}
                      >
                        {
                          <Box mr={2}>
                            {choosenFile.length != 0 ? (
                              <Image fontSize="large" color="primary" />
                            ) : (
                              <Attachment fontSize="large" color="action" />
                            )}
                          </Box>
                        }
                        <input {...getInputProps()} />

                        {choosenFile.length != 0 ? (
                          <Box display="flex" alignItems="center">
                            <Typography color="primary">
                              {choosenFile[0].name}
                            </Typography>
                            <IconButton onClick={() => setChoosenFile([])}>
                              <Close />
                            </IconButton>
                          </Box>
                        ) : (
                          !isDragActive && (
                            <Typography color="textPrimary">
                              Drop the logo here or click to upload...
                            </Typography>
                          )
                        )}

                        {isDragActive && !isDragReject && (
                          <Typography color="primary">Drop it here!</Typography>
                        )}
                        {isDragReject && (
                          <Typography color="error">
                            File type not accepted, sorry!
                          </Typography>
                        )}
                      </Box>
                    </CardActionArea>
                  )}
                </Dropzone>
              </Box>
            )}
            <Box display="flex" mb={2} justifyContent="center">
              {choosenFile.length != 0 && (
                <Button
                  className={classes.btn}
                  disableElevation
                  variant="outlined"
                  color="primary"
                  onClick={changeLogo}
                  disabled={operators.saving}
                >
                  {operators.saving ? (
                    <CircularProgress size={25} />
                  ) : (
                    "Change logo"
                  )}
                </Button>
              )}
            </Box>
          </Grid>

          <Grid item xs={12} md={12}>
            <Paper elevation={0} className={classes.paper}>
              <DialogContent>
                {/* <Box mt={1} mb={1}>
            <LinearProgress variant="determinate" value={40} />
          </Box> */}

                <Box width={1}>
                  {!operators.edit ? (
                    <>
                      <Box display="flex" justifyContent="space-between">
                        <Box>
                          {" "}
                          <Permissions permissions="CAN_EDIT_OPERATOR">
                            {" "}
                            <Box mb={1} display="flex" justifyContent="center">
                              <Button
                                color="primary"
                                size="large"
                                className={classes.btn}
                                startIcon={<Edit />}
                                onClick={() =>
                                  setOperators({ ...operators, edit: true })
                                }
                              >
                                Edit operator info
                              </Button>
                            </Box>
                          </Permissions>
                        </Box>

                        <Box display="flex" alignItems="center">
                          <Box display="flex" justifyContent="center">
                            <Permissions permissions="CAN_ENABLE_OPERATOR">
                              {" "}
                              <Button
                                className={classes.btn}
                                style={{
                                  color:
                                    data.organization_status == "ENABLED"
                                      ? Theme.palette.error.main
                                      : Theme.palette.primary.main,
                                }}
                                size="large"
                                color="inherit"
                                startIcon={
                                  operators.toggling ? (
                                    <CircularProgress size={25} />
                                  ) : data.organization_status == "ENABLED" ? (
                                    <Block />
                                  ) : (
                                    <CheckCircle />
                                  )
                                }
                                disabled={operators.toggling}
                                onClick={() =>
                                  data.organization_status == "ENABLED"
                                    ? setWarning(true)
                                    : toggleOperator()
                                }
                                disableElevation
                              >
                                {data.organization_status == "ENABLED"
                                  ? "Deactivate operator"
                                  : "Reactivate operator"}
                              </Button>
                            </Permissions>
                          </Box>
                        </Box>
                      </Box>
                      <Divider variant="middle" />
                    </>
                  ) : (
                    <Stepper
                      activeStep={activeStep}
                      alternativeLabel
                      style={{ padding: 0 }}
                    >
                      {steps.map((label) => (
                        <Step key={label}>
                          <StepLabel>{label}</StepLabel>
                        </Step>
                      ))}
                    </Stepper>
                  )}
                  <div>
                    {activeStep === steps.length ? (
                      <div>
                        <Typography className={classes.instructions}>
                          All steps completed
                        </Typography>
                        <Button>Reset</Button>
                      </div>
                    ) : (
                      <div>
                        {activeStep == 0 ? (
                          <Box>
                            <Box mt={2}>
                              <Translate>
                                {({ translate }) => (
                                  <TextField
                                    size="small"
                                    variant="standard"
                                    color="primary"
                                    type="text"
                                    InputProps={{
                                      disableUnderline: !operators.edit,
                                      readOnly: !operators.edit,
                                    }}
                                    value={operatorName.value}
                                    placeholder={translate(
                                      "operators.forms.hints.operator_name"
                                    )}
                                    label={
                                      <Translate id="operators.forms.labels.operator_name" />
                                    }
                                    fullWidth
                                    onChange={onNameChange}
                                    helperText={operatorName.error}
                                    error={operatorName.error !== ""}
                                  />
                                )}
                              </Translate>
                            </Box>
                            <Box mt={2}>
                              <Translate>
                                {({ translate }) => (
                                  <TextField
                                    size="small"
                                    variant="standard"
                                    color="primary"
                                    type="text"
                                    InputProps={{
                                      disableUnderline: !operators.edit,
                                      readOnly: !operators.edit,
                                    }}
                                    value={operatorEmail.value}
                                    placeholder={translate(
                                      "operators.forms.hints.operator_email"
                                    )}
                                    label={
                                      <Translate id="operators.forms.labels.operator_email" />
                                    }
                                    fullWidth
                                    onChange={onEmailChange}
                                    helperText={operatorEmail.error}
                                    error={operatorEmail.error !== ""}
                                  />
                                )}
                              </Translate>
                            </Box>
                            <Box mt={2}>
                              <Translate>
                                {({ translate }) => (
                                  <TextField
                                    size="small"
                                    variant="standard"
                                    color="primary"
                                    type="text"
                                    InputProps={{
                                      disableUnderline: !operators.edit,
                                      readOnly: !operators.edit,
                                    }}
                                    value={operatorPhone.value}
                                    placeholder={translate(
                                      "operators.forms.hints.operator_phone"
                                    )}
                                    label={
                                      <Translate id="operators.forms.labels.operator_phone" />
                                    }
                                    fullWidth
                                    onChange={onPhoneChange}
                                    helperText={operatorPhone.error}
                                    error={operatorPhone.error !== ""}
                                  />
                                )}
                              </Translate>
                            </Box>
                            <Box mt={2}>
                              <Translate>
                                {({ translate }) => (
                                  <TextField
                                    size="small"
                                    variant="standard"
                                    color="primary"
                                    type="text"
                                    InputProps={{
                                      disableUnderline: !operators.edit,
                                      readOnly: !operators.edit,
                                    }}
                                    value={operatorAddress.value}
                                    placeholder={translate(
                                      "operators.forms.hints.operator_address"
                                    )}
                                    label={
                                      <Translate id="operators.forms.labels.operator_address" />
                                    }
                                    fullWidth
                                    onChange={onAddressChange}
                                    helperText={operatorAddress.error}
                                    error={operatorAddress.error !== ""}
                                  />
                                )}
                              </Translate>
                            </Box>
                            <Box mt={2}>
                              <Translate>
                                {({ translate }) => (
                                  <TextField
                                    size="small"
                                    variant="standard"
                                    color="primary"
                                    type="text"
                                    InputProps={{
                                      disableUnderline: !operators.edit,
                                      readOnly: !operators.edit,
                                    }}
                                    value={operatorShortName.value}
                                    placeholder={translate(
                                      "operators.forms.hints.operator_short_name"
                                    )}
                                    label={
                                      <Translate id="operators.forms.labels.operator_short_name" />
                                    }
                                    fullWidth
                                    onChange={onShortNameChange}
                                    helperText={operatorShortName.error}
                                    error={operatorShortName.error !== ""}
                                  />
                                )}
                              </Translate>
                            </Box>

                            <Box mt={2}>
                              <Translate>
                                {({ translate }) => (
                                  <TextField
                                    size="small"
                                    variant="standard"
                                    color="primary"
                                    type="text"
                                    InputProps={{
                                      disableUnderline: !operators.edit,
                                      readOnly: !operators.edit,
                                    }}
                                    value={operatorWebsite.value}
                                    placeholder={translate(
                                      "operators.forms.hints.operator_website"
                                    )}
                                    label={
                                      <Translate id="operators.forms.labels.operator_website" />
                                    }
                                    fullWidth
                                    onChange={onWebsiteChange}
                                    helperText={operatorWebsite.error}
                                    error={operatorWebsite.error !== ""}
                                  />
                                )}
                              </Translate>
                            </Box>

                            <Box mt={2}>
                              <Translate>
                                {({ translate }) => (
                                  <TextField
                                    size="small"
                                    variant="standard"
                                    color="primary"
                                    type="text"
                                    InputProps={{
                                      disableUnderline: !operators.edit,
                                      readOnly: !operators.edit,
                                    }}
                                    value={operatorTin.value}
                                    placeholder={translate(
                                      "operators.forms.hints.operator_tin"
                                    )}
                                    label={
                                      <Translate id="operators.forms.labels.operator_tin" />
                                    }
                                    fullWidth
                                    onChange={onTinChange}
                                    helperText={operatorTin.error}
                                    error={operatorTin.error !== ""}
                                  />
                                )}
                              </Translate>
                            </Box>

                            <Box mt={2}>
                              <Translate>
                                {({ translate }) => (
                                  <TextField
                                    size="small"
                                    variant="standard"
                                    color="primary"
                                    type="text"
                                    InputProps={{
                                      disableUnderline: !operators.edit,
                                      readOnly: !operators.edit,
                                    }}
                                    value={operatorZip.value}
                                    placeholder={translate(
                                      "operators.forms.hints.operator_zip"
                                    )}
                                    label={
                                      <Translate id="operators.forms.labels.operator_zip" />
                                    }
                                    fullWidth
                                    onChange={onZipChange}
                                    helperText={operatorZip.error}
                                    error={operatorZip.error !== ""}
                                  />
                                )}
                              </Translate>
                            </Box>
                            <Box mt={2}>
                              <Translate>
                                {({ translate }) => (
                                  <TextField
                                    size="small"
                                    variant="standard"
                                    color="primary"
                                    type="text"
                                    InputProps={{
                                      disableUnderline: !operators.edit,
                                      readOnly: !operators.edit,
                                    }}
                                    value={operatorFax.value}
                                    placeholder={translate(
                                      "operators.forms.hints.operator_fax"
                                    )}
                                    label={
                                      <Translate id="operators.forms.labels.operator_fax" />
                                    }
                                    fullWidth
                                    onChange={onFaxChange}
                                    helperText={operatorFax.error}
                                    error={operatorFax.error !== ""}
                                  />
                                )}
                              </Translate>
                            </Box>
                            <Box mt={2}>
                              <Translate>
                                {({ translate }) => (
                                  <TextField
                                    size="small"
                                    variant="standard"
                                    color="primary"
                                    type="text"
                                    InputProps={{
                                      disableUnderline: !operators.edit,
                                      readOnly: !operators.edit,
                                    }}
                                    value={operatorContractNumber.value}
                                    placeholder={translate(
                                      "operators.forms.hints.operator_contract_number"
                                    )}
                                    label={
                                      <Translate id="operators.forms.labels.operator_contract_number" />
                                    }
                                    fullWidth
                                    onChange={onContractNumberChange}
                                    helperText={operatorContractNumber.error}
                                    error={operatorContractNumber.error !== ""}
                                  />
                                )}
                              </Translate>
                            </Box>
                            <Box mt={2}>
                              <Translate>
                                {({ translate }) => (
                                  <TextField
                                    size="small"
                                    variant="standard"
                                    color="primary"
                                    type="text"
                                    InputProps={{
                                      disableUnderline: !operators.edit,
                                      readOnly: !operators.edit,
                                    }}
                                    value={operatorSettlementBankAccount.value}
                                    placeholder={translate(
                                      "operators.forms.hints.operator_settlement_bank_account"
                                    )}
                                    label={
                                      <Translate id="operators.forms.labels.operator_settlement_bank_account" />
                                    }
                                    fullWidth
                                    onChange={onSettlementBankAccountChange}
                                    helperText={
                                      operatorSettlementBankAccount.error
                                    }
                                    error={
                                      operatorSettlementBankAccount.error !== ""
                                    }
                                  />
                                )}
                              </Translate>
                            </Box>
                            <Box mt={2}>
                              <Translate>
                                {({ translate }) => (
                                  <TextField
                                    size="small"
                                    variant="standard"
                                    color="primary"
                                    type="text"
                                    InputProps={{
                                      disableUnderline: !operators.edit,
                                      readOnly: !operators.edit,
                                    }}
                                    value={operatorSettlementBankAccountName.value}
                                    placeholder={translate(
                                      "operators.forms.hints.operator_settlement_bank_account_name"
                                    )}
                                    label={
                                      <Translate id="operators.forms.labels.operator_settlement_bank_account_name" />
                                    }
                                    fullWidth
                                    onChange={onSettlementBankAccountNameChange}
                                    helperText={
                                      operatorSettlementBankAccountName.error
                                    }
                                    error={
                                      operatorSettlementBankAccountName.error !== ""
                                    }
                                  />
                                )}
                              </Translate>
                            </Box>
                           {data.organization_type == "OPERATOR" ? <Box mt={2}>
                              <FormControl
                                fullWidth
                                variant="standard"
                                size="small"
                                error={bankCode.error !== ""}
                                //  disabled={!operators.edit}
                              >
                                <InputLabel>
                                  <Translate id="operators.forms.labels.operator_settlement_bank_code" />
                                </InputLabel>
                                <Select
                                  inputProps={{
                                    disableUnderline: !operators.edit,
                                    readOnly: !operators.edit,
                                  }}
                                  label={
                                    <Translate id="operators.forms.labels.operator_settlement_bank_code" />
                                  }
                                  value={bankCode.value}
                                  onChange={onBankCode}
                                >
                                  {new AdminService()
                                    .getBankCodes()
                                    .map((loc, i) => (
                                      <MenuItem value={loc.code}>
                                        {loc.name}
                                      </MenuItem>
                                    ))}
                                </Select>
                                <FormHelperText>
                                  {bankCode.error}
                                </FormHelperText>
                              </FormControl>
                            </Box>:<></>}
                            {data.organization_type == "CENTRIKA" ? (
                              <Box mt={2}>
                                <Translate>
                                  {({ translate }) => (
                                    <TextField
                                      size="small"
                                      variant="standard"
                                      color="primary"
                                      type="text"
                                      multiline
                                      rows={3}
                                      rowsMax={5}
                                      InputProps={{
                                        disableUnderline: !operators.edit,
                                        readOnly: !operators.edit,
                                      }}
                                      value={posConfig.value}
                                      placeholder={translate(
                                        "operators.forms.hints.pos_config"
                                      )}
                                      label={
                                        <Translate id="operators.forms.labels.pos_config" />
                                      }
                                      fullWidth
                                      onChange={onPosConfigChange}
                                      helperText={posConfig.error}
                                      error={posConfig.error !== ""}
                                    />
                                  )}
                                </Translate>
                              </Box>
                            ) : (
                              <></>
                            )}
                            <Box mt={2}>
                              <DatePicker
                                fullWidth
                                disableToolbar
                                variant="inline"
                                format="yyyy-MM-dd"
                                margin="dense"
                                autoOk
                                label={
                                  <Translate id="operators.forms.labels.operator_contract_start" />
                                }
                                value={operatorCotractStart.value}
                                inputVariant="standard"
                                onChange={onCnotractStartChange}
                                InputProps={{
                                  disableUnderline: !operators.edit,
                                  readOnly: !operators.edit,
                                  style: { paddingRight: 0 },
                                }}
                              />
                            </Box>
                            <Box mt={2}>
                              <DatePicker
                                fullWidth
                                disableToolbar
                                variant="inline"
                                format="yyyy-MM-dd"
                                margin="dense"
                                autoOk
                                label={
                                  <Translate id="operators.forms.labels.operator_contract_end" />
                                }
                                value={operatorContractEnd.value}
                                inputVariant="standard"
                                onChange={onContractEndChange}
                                InputProps={{
                                  disableUnderline: !operators.edit,
                                  readOnly: !operators.edit,
                                  style: { paddingRight: 0 },
                                }}
                              />
                            </Box>
                          </Box>
                        ) : (
                          <Box m={4}>
                            <Typography align="center">
                              <Translate id="operators.forms.dialog_desc" />
                            </Typography>
                          </Box>
                        )}
                      </div>
                    )}
                  </div>

                  <Box mt={3} />
                  {operators.edit && (
                    <DialogActions>
                      <Button
                        variant="outlined"
                        color="primary"
                        disableElevation
                        className={classes.btn}
                        onClick={() => {
                          activeStep === 0
                            ? setOperators({ ...operators, edit: false })
                            : handleBack();
                        }}
                      >
                        {activeStep === 0 ? (
                          <Translate id="operators.forms.buttons.cancel" />
                        ) : (
                          <Translate id="operators.forms.buttons.back" />
                        )}
                      </Button>

                      <Button
                        variant="contained"
                        color="primary"
                        disableElevation
                        className={classes.btn}
                        disabled={operators.saving}
                        onClick={() => {
                          onRegisterClick();
                        }}
                      >
                        {operators.saving ? (
                          <CircularProgress size={25} />
                        ) : activeStep === steps.length - 1 ? (
                          <Translate id="operators.forms.buttons.save" />
                        ) : (
                          <Translate id="operators.forms.buttons.continue" />
                        )}
                      </Button>
                    </DialogActions>
                  )}
                </Box>
              </DialogContent>
            </Paper>
          </Grid>
        </Grid>
      </div>
    </MuiPickersUtilsProvider>
  );
}

export default withLocalize(OperatorDetails);
